<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="用户邮箱" prop="email">
                <a-input v-model="queryParam.email" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">未审核</a-select-option>
                  <a-select-option :value="1">审核未通过</a-select-option>
                  <a-select-option :value="2">审核通过未打款</a-select-option>
                  <a-select-option :value="3">已打款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1800}"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />审核
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageWithdraw,listWithdraw, delWithdraw } from '@/api/user/withdraw'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Withdraw',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        nickname: null,
        email: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: '用户邮箱',
          dataIndex: 'email',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: '提现金额',
          dataIndex: 'money',
          width: 120,
          align: 'center'
        },
        {
          title: '实际到账金额',
          dataIndex: 'realMoney',
          width: 120,
          align: 'center'
        },
        {
          title: '提现手续费',
          dataIndex: 'serviceChargeNum',
          width: 120,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,
          align: 'center',
          customRender: function (status) {
            if (status === 0) {
              return '未审核'
            } else if (status === 1) {
              return '审核未通过'
            } else if (status === 2) {
              return '审核通过未打款'
            } else if (status === 3) {
              return '已打款'
            }
          }
        },
        {
          title: '提现方式',
          dataIndex: 'withdrawType',
          width: 120,
          align: 'center',
          customRender: function (withdrawType) {
            if (withdrawType === 0) {
              return 'Touch′n Go'
            } else if (withdrawType === 1) {
              return '银行卡'
            }
          }
        },
        {
          title: '提现类型',
          dataIndex: 'withdrawUserType',
          width: 120,
          align: 'center',
          customRender: function (withdrawUserType) {
            if (withdrawUserType === 1) {
              return '分销收益提现'
            }
          }
        },
        {
          title: '第三方订单号',
          dataIndex: 'orderNo',
          width: 180,
          align: 'center'
        },
        {
          title: '失败原因',
          dataIndex: 'failureReason',
          width: 220,
          align: 'center',
          customRender: function (failureReason) {
            if (failureReason) {
              return failureReason
            } else {
              return '无'
            }
          }
        },
        {
          title: '审核意见',
          dataIndex: 'auditOpinion',
          width: 220,
          align: 'center',
          customRender: function (auditOpinion) {
            if (auditOpinion) {
              return auditOpinion
            } else {
              return '无'
            }
          }
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 200,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户提现记录列表 */
    getList () {
      this.loading = true
      pageWithdraw(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        money: undefined,
        realMoney: undefined,
        serviceChargeNum: undefined,
        status: undefined,
        withdrawType: undefined,
        withdrawUserType: undefined,
        orderNo: undefined,
        failureReason: undefined,
        auditOpinion: undefined,
        cateName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delWithdraw(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-withdraw/export', {
            ...that.queryParam
          }, `用户提现记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
